// src/components/Appointments/QuickActionsBar.jsx
// ✅ CLEAN VERSION - Simple & Responsive

import React, { useState } from "react";
import {
  FiUser,
  FiClock,
  FiFlag,
  FiEdit,
  FiZap,
  FiTarget,
} from "react-icons/fi";
import AdminAssignmentModal from "./AdminAssignmentModal";
import AppointmentFieldUpdateModal from "./AppointmentFieldUpdateModal";

const QuickActionsBar = ({ appointment, onRefresh }) => {
  const [showAdminModal, setShowAdminModal] = useState(false);
  const [showFieldModal, setShowFieldModal] = useState(false);
  const [fieldType, setFieldType] = useState(null);

  console.log("Appointment Data in QuickActionsBar:", appointment);

  if (!appointment) return null;

  const canModify =
    appointment.status === "PENDING" ||
    appointment.status === "CONFIRMED" ||
    appointment.status === "CHECKED_IN";

  const handleOpenFieldModal = (type) => {
    setFieldType(type);
    setShowFieldModal(true);
  };

  const handleSuccess = () => {
    onRefresh?.();
  };

  const actions = [
    {
      id: "admin",
      icon: FiUser,
      label: appointment.adminCode ? "Reassign Admin" : "Assign Admin",
      value: appointment.adminCode ? appointment.adminName : "Not assigned",
      onClick: () => setShowAdminModal(true),
    },
    {
      id: "duration",
      icon: FiClock,
      label: "Duration",
      value: `${appointment.duration} min`,
      onClick: () => handleOpenFieldModal("duration"),
    },
    {
      id: "priority",
      icon: FiFlag,
      label: "Priority",
      value: appointment.priority || "MEDIUM",
      onClick: () => handleOpenFieldModal("priority"),
    },
    {
      id: "type",
      icon: FiEdit,
      label: "Type",
      value: appointment.type?.replace(/_/g, " ") || "Not set",
      onClick: () => handleOpenFieldModal("type"),
    },
    {
      id: "intent",
      icon: FiTarget,
      label: "Intent",
      value: appointment.intent?.purpose?.replace(/_/g, " ") || "Not set",
      onClick: () => handleOpenFieldModal("intent"),
    },
  ];

  return (
    <>
      <div className="bg-white rounded-lg shadow-sm border border-neutral-light p-4 sm:p-5 mb-6">
        {/* Header */}
        <div className="flex items-center gap-2 mb-4">
          <FiZap className="text-primary" size={20} />
          <h3 className="font-semibold text-text">Quick Actions</h3>
        </div>

        {/* Actions Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3">
          {actions.map((action) => {
            const Icon = action.icon;
            return (
              <button
                key={action.id}
                onClick={action.onClick}
                disabled={!canModify}
                className={`p-4 rounded-lg border transition-colors text-left ${
                  canModify
                    ? "border-neutral-light hover:border-primary  bg-white"
                    : "border-neutral-light bg-neutral-light opacity-50 cursor-not-allowed"
                }`}
              >
                <Icon className="text-primary mb-2" size={20} />
                <div className="font-medium text-sm text-text mb-1">
                  {action.label}
                </div>
                <div className="text-xs text-neutral-dark truncate">
                  {action.value}
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {/* Modals */}
      <AdminAssignmentModal
        isOpen={showAdminModal}
        onClose={() => setShowAdminModal(false)}
        appointment={appointment}
        onSuccess={handleSuccess}
      />

      <AppointmentFieldUpdateModal
        isOpen={showFieldModal}
        onClose={() => setShowFieldModal(false)}
        appointment={appointment}
        fieldType={fieldType}
        onSuccess={handleSuccess}
      />
    </>
  );
};

export default QuickActionsBar;
